// Contact Messages Management Permissions

export const CONTACT_MESSAGES_VIEW = 280;
export const CONTACT_MESSAGES_UPDATE = 281;
export const CONTACT_MESSAGES_DELETE = 282;

// Registered by the amer-laravel migration
// 2026_08_19_000002_add_financial_tree_and_contact_message_restore_permissions. The id
// below is the central-assigned approval number and must be confirmed against the central
// permission-key registry before release.
/** contact_messages.restore */
export const CONTACT_MESSAGES_RESTORE = 1467;
